export function formatGermanDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return '';
  return d.toLocaleDateString('de-DE');
}

export function toInputDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return '';
  const pad = (n) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function buildQueryString(params) {
  const query = new URLSearchParams();
  if (params.t?.length) params.t.forEach((value) => query.append('t', value));
  if (params.lfdn?.length)
    params.lfdn.forEach((value) => query.append('lfdn', value));
  if (params.participant?.length)
    params.participant.forEach((value) => query.append('participant', value));
  if (params.keyValues) {
    Object.entries(params.keyValues).forEach(([key, values]) => {
      values.forEach((value) => {
        if (key && value) query.append(`key:${key}`, value);
      });
    });
  }
  if (params.createdAtStart)
    query.append('created_at_start', params.createdAtStart);
  if (params.createdAtEnd) {
    const end = new Date(params.createdAtEnd);
    end.setDate(end.getDate() + 1);
    query.append('created_at_end', end.toISOString().slice(0, 10));
  }
  if (params.uploadedAtStart)
    query.append('uploaded_at_start', params.uploadedAtStart);
  if (params.uploadedAtEnd) {
    const end = new Date(params.uploadedAtEnd);
    end.setDate(end.getDate() + 1);
    query.append('uploaded_at_end', end.toISOString().slice(0, 10));
  }
  if (params.completed_surveys?.length) {
    params.completed_surveys.forEach((value) =>
      query.append('completed_surveys', value)
    );
  }
  query.append('page', params.page);
  if (params.page_size !== undefined && params.page_size !== null) {
    query.append('page_size', params.page_size);
  }
  if (params.only_collisions) {
    query.append('only_collisions', params.only_collisions);
  }

  return query.toString();
}

export function getExportFilename() {
  const now = new Date();
  return `surveys_export_${now.toISOString().slice(0, 10)}.csv`;
}
